import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import ContentfulUtil from "../util/ContentfulUtil";
import Location from "../components/show/Location";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import Dates from "../components/show/Dates";
import NotFound from "./NotFound";
import Tickets from "../components/show/Tickets";

export default function SingleEvent() {
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const events = await ContentfulUtil.getNonShowEvents();

                const match = events.find((e) => e.fields.url === id);

                if (!match) {
                    setError(true);
                    return;
                }

                setEvent(match);
            } catch (err) {
                console.error("Error loading event:", err);
                setError(true);
            }
        };

        fetchData();
    }, [id]);

    if (error) return <NotFound />;

    if (!event) {
        return (
            <>
                <PageTitle>Loading Event...</PageTitle>
                <PageContent>Loading Event...</PageContent>
            </>
        );
    }

    const fields = event.fields;

    const formattedPrice =
        fields.eventCost && !isNaN(fields.eventCost)
            ? `$${fields.eventCost}`
            : fields.eventCost;

    return (
        <>
            <PageTitle>
                <div className="list-inline-item text-white h3 font-secondary nasted">
                    {fields.name}
                </div>
            </PageTitle>

            <PageContent>
                <div className="row">
                    <div className="col-12 mb-4">
                        <img
                            src={
                                fields.mainImage?.fields?.file?.url
                                    ? `https:${fields.mainImage.fields.file.url}`
                                    : ""
                            }
                            alt={fields.name}
                            className="img-fluid w-100"
                        />
                    </div>
                </div>

                <div className="row align-items-center mb-5">
                    <div className="col-lg-9">
                        <ul className="list-inline">

                            <li className="list-inline-item mr-xl-5 mr-4 mb-3 mb-lg-0">
                                <Location location={fields.location} />
                            </li>

                            <li className="list-inline-item mr-xl-5 mr-4 mb-3 mb-lg-0">
                                <Dates
                                    dates={fields.eventDate ? [fields.eventDate] : []}
                                    text="EVENT DATE"
                                />
                            </li>

                            <li className="list-inline-item mr-xl-5 mr-4 mb-3 mb-lg-0">
                                <Tickets ticketCost={formattedPrice} />
                            </li>

                            {/* <li className="list-inline-item mr-xl-5 mr-4 mb-3 mb-lg-0">
                                <p className="mb-0">
                                    <i className="ti-ticket text-primary mr-2" />
                                    {formattedPrice}
                                </p>
                            </li> */}

                        </ul>
                    </div>

                    {fields.signUpLink && (
                        <a
                            href={fields.signUpLink}
                            className="btn btn-primary"
                            style={{ marginBottom: "25px" }}
                        >
                            Sign Up
                        </a>
                    )}

                    <div className="col-12 mt-4 order-4">
                        <div className="border-bottom border-primary" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mb-50">
                        {fields.eventInformation &&
                            documentToReactComponents(fields.eventInformation)}
                    </div>
                </div>
            </PageContent>
        </>
    );
}